module.exports = __webpack_public_path__ + "static/media/label-7.452ea800.svg";